// services/cacheService.js - Clean version (if you update apiService above)
import apiService from './api';

export const cacheService = {
  async refreshFinanceCache(year = null, endpoint = null, accountingMethod = 'Accrual') {
    try {
      const params = { accounting_method: accountingMethod };
      if (year) params.year = year;
      if (endpoint) params.endpoint = endpoint;

      const response = await apiService.post('/finance/cache/refresh', null, params);
      return response;
    } catch (error) {
      console.error('Error refreshing finance cache:', error);
      throw error;
    }
  },

  async getCacheStats() {
    try {
      const response = await apiService.get('/finance/cache/stats');
      return response;
    } catch (error) {
      console.error('Error getting cache stats:', error);
      throw error;
    }
  },

  async clearCache(year = null, endpoint = null, accountingMethod = null) {
    try {
      const params = {};
      if (year) params.year = year;
      if (endpoint) params.endpoint = endpoint;
      if (accountingMethod) params.accounting_method = accountingMethod;

      const response = await apiService.delete('/finance/cache/clear', params);
      return response;
    } catch (error) {
      console.error('Error clearing cache:', error);
      throw error;
    }
  },

  async refreshPlaygroundCache(year = null, accountingMethod = 'Accrual') {
    try {
      const params = { accounting_method: accountingMethod };
      if (year) params.year = year;

      const response = await apiService.post('/pl-scenario/cache/refresh', null, params);
      return response;
    } catch (error) {
      console.error('Error refreshing playground cache:', error);
      throw error;
    }
  },

  async refreshTimeActivityCache(yearMonth = null) {
    try {
      const params = {};
      if (yearMonth) params.year_month = yearMonth;

      const response = await apiService.post('/time-activity/cache/refresh', null, params);
      return response;
    } catch (error) {
      console.error('Error refreshing time activity cache:', error);
      throw error;
    }
  },

  async refreshSalesCache(year = null) {
    try {
        const params = {};
        if (year) params.year = year;

        const response = await apiService.post('/sales/cache/refresh', null, params);
        return response;
    } catch (error) {
        console.error('Error refreshing sales cache:', error);
        throw error;
    }
    }
};